<template>
  <div>
    <common-title :title="$t('common.personCenterInfo')"></common-title>
    <div class="outBig outBigc">
      <div class="outdiv">
        <el-form
          :model="ruleForm"
          :rules="editMode ? rules : {}"
          ref="ruleForm"
          size="mini"
          :label-width="$i18n.locale == 'zh' ? '120px' : '220px'"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('common.account')" prop="account">
            <span :class="ruleForm.account ? '' : 'nullSpan'">{{
              IsNull(ruleForm.account)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.role')" prop="role">
            <span v-if="$i18n.locale == 'en' && ruleForm.roleEn">{{
              ruleForm.roleEn
            }}</span>
            <span v-else>{{ ruleForm.role }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.name')" prop="name">
            <el-input
              v-if="editMode"
              v-model="ruleForm.name"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span v-if="!editMode">{{ ruleForm.name }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.sex')" prop="sex">
            <div v-if="editMode">
              <el-radio v-model="ruleForm.sex" label="男">{{
                $t("common.Male")
              }}</el-radio>
              <el-radio v-model="ruleForm.sex" label="女">{{
                $t("common.Female")
              }}</el-radio>
            </div>
            <span v-if="!editMode">
              <span v-if="ruleForm.sex == '男'">{{ $t("common.Male") }}</span>
              <span v-if="ruleForm.sex == '女'">{{ $t("common.Female") }}</span>
            </span>
          </el-form-item>
          <el-form-item :label="$t('common.jigou')" prop="org">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="ruleForm.org"
              maxlength="1000"
              show-word-limit
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <!--          <span  v-if="!editMode">{{ruleForm.org}}</span>-->
            <span v-if="!editMode" :class="ruleForm.org ? '' : 'nullSpan'">{{
              IsNull(ruleForm.org)
            }}</span>
            <organ-add-component
              ref="organ-add-component"
              @choseOrgan="choseOrgan"
            ></organ-add-component>
          </el-form-item>
          <el-form-item :label="$t('common.bindingEmail')" prop="contactEmail">
            <span :class="ruleForm.contactEmail ? '' : 'nullSpan'">{{
              IsNull(ruleForm.contactEmail)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.bindingPhone')" prop="phoneNumber">
            <span :class="ruleForm.phoneNumber ? '' : 'nullSpan'">{{
              IsNull(ruleForm.phoneNumber)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.otherEmail')" prop="reserveEmail">
            <el-input
              v-if="editMode"
              v-model="ruleForm.reserveEmail"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <!--          <span v-if="!editMode">{{ruleForm.reserveEmail}}</span>-->
            <span
              v-if="!editMode"
              :class="ruleForm.reserveEmail ? '' : 'nullSpan'"
              >{{ IsNull(ruleForm.reserveEmail) }}</span
            >
          </el-form-item>
          <el-form-item
            :label="$t('common.otherPhone')"
            prop="reservePhoneNumber"
          >
            <el-input
              v-if="editMode"
              v-model="ruleForm.reservePhoneNumber"
              placeholder="请填写手机号，以便于联系"
            ></el-input>
            <span
              v-if="!editMode"
              :class="ruleForm.reservePhoneNumber ? '' : 'nullSpan'"
              >{{ ruleForm.reservePhoneNumber?ruleForm.reservePhoneNumber:'请填写手机号，以便于联系' }}</span
            >
          </el-form-item>
         
          <!--      评审员无该项-->
          <el-form-item
            v-if="authorityObj.isShow('#5#64#66')"
            :label="$t('common.isWill')"
            prop="isWillReview"
          >
            <div v-if="editMode">
              <el-radio v-model="ruleForm.isWillReview" :label="1">{{
                $t("common.Yes")
              }}</el-radio>
              <el-radio v-model="ruleForm.isWillReview" :label="0">{{
                $t("common.No")
              }}</el-radio>
            </div>
            <span v-if="!editMode">{{
              ruleForm.isWillReview == "1" ? $t("common.Yes") : $t("common.No")
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.research')" prop="researchField">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="ruleForm.researchField"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="ruleForm.researchField ? '' : 'nullSpan'"
              >{{ IsNull(ruleForm.researchField) }}</span
            >
          </el-form-item>
          <el-form-item :label="$t('common.remark')" prop="remarks">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="ruleForm.remarks"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="ruleForm.remarks ? '' : 'nullSpan'"
              >{{ IsNull(ruleForm.remarks) }}</span
            >
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="!editMode"
              type="primary"
              @click="modifyFrom('ruleForm')"
              >{{ $t("common.edit") }}</el-button
            >
            <!--        <el-button @click="resetForm('ruleForm')">重置</el-button>-->
            <el-button
              v-if="editMode"
              type="primary"
              @click="submitForm('ruleForm')"
              >{{ $t("common.confirmEdit") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="userCenterImgOut">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :headers="importHeaders"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :before-upload="beforeUpload"
        >
          <el-image
            v-if="ruleForm.icon"
            :src="ruleForm.icon"
            class="avatar"
            fit="cover"
            @error="$oss.userIcon"
          />
          <img v-else :src="$oss.userIcon" />
          <span class="upload-tip">{{ $t("common.changeUserIcon") }}</span>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import commonTitle from "@/components/common/commonTitle";
import tagComponent from "@/components/meeting/tagComponent";
import config from "@/api/config";
import organAddComponent from "@/components/paper/createUser/organAddComponent";
export default {
  data() {
    return {
      importHeaders: {
        authorization: "",
      },
      editMode: false, //编辑模式。
      ruleForm: {
        account: "",
        role: "",
        name: "",
        sex: "",
        org: "",
        orgCode: "",
        email: "",
        phoneNumber: "",
        reserveEmail: "",
        reservePhoneNumber: "",
        isWillReview: "",
        researchField: "",
        remarks: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("msg.enterName"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 300,
            message: this.$t("msg.enterLength"),
            trigger: "blur",
          },
        ],
        reserveEmail: [
          { required: true, message: this.$t("common.pleaseInputEmail"), trigger: "blur" },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: this.$t("msg.rightEmail"),
            trigger: "blur",
          },
        ],
        org: [
          { required: true, message: this.$t("msg.enterIns"), trigger: "blur" },
        ],
        sex: [
          { required: true, message: this.$t("msg.choseSex"), trigger: "blur" },
        ],
      },

      //请求回的数据
      personInfo: {
        account: "",
        role: "",
        name: "",
        sex: "",
        org: "",
        email: "",
        phoneNumber: "",
        reserveEmail: "",
        reservePhoneNumber: "",
        isWillReview: "",
        researchField: "",
        remarks: "",
        //icon:'https://financial-search.oss-cn-beijing.aliyuncs.com/web-resource/common/user-icon.png',
        icon: "",
      },

      chianFormData: null,
      chianTags: [], //征文主题数组。
      englishFormData: null,
      englishTags: [], //征文主题数组。

      // 头像相关
      // uploadUrl: config.baseURL+ "/file/upload",
      //uploadUrl: 'http://47.104.20.126:20201/financial-search/api'+ "/file/upload",
      uploadUrl: config.baseURL + "/conference/userinfo/stream",
    };
  },
  components: {
    tagComponent,
    commonTitle,
    organAddComponent,
  },
  created() {
    this.getCrUserInfo();
    this.importHeaders.authorization = this.$store.state.dict.authorization;
  },
  methods: {
    modifyFrom(formName) {
      this.editMode = !this.editMode;
    },
    choseOrgan(item) {
      this.ruleForm.organCode = item.organCode;
      this.ruleForm.org = item.organName;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.upDataUserInfo(this.ruleForm, "post").then((resData) => {
            if (resData.code == 200) {
              this.$message({
                message: this.$t("msg.successMsg"),
                type: "success",
              });
              //this.ruleForm=resData.data;
            } else {
              this.$message({
                message: this.$t("msg.tryAgain"),
                type: "error",
              });
            }
          });
          this.editMode = !this.editMode;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tags = [];
    },
    //头像相关
    // 上传图片成功
    uploadSuccess(res, file) {
      if (res.data.data && res.data.data.fileLink) {
        this.ruleForm.icon = res.data.data.fileLink;
        this.$api.upDataUserInfo(this.ruleForm, "post").then((resData) => {
          if (resData.code == 200) {
            this.$store.commit("setCurrentUserIcon", this.ruleForm.icon);
            this.$message({
              message: "操作成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: this.$t("msg.tryAgain"),
              type: "error",
            });
          }
        });
      }
    },

    getCrUserInfo() {
      this.$api.getCrUserInfo({}, "get").then((resData) => {
        if (resData.code == 200) {
          this.ruleForm = resData.data;
          this.ruleForm.phoneNumber = resData.data.phone;
        } else {
          this.$message({
            message: "操作失败，请稍后重试",
            type: "error",
          });
        }
      });
    },

    // 上传图片前文件校验
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped lang="scss">
.outBig {
  display: flex;
  justify-content: left;
  .outdiv {
    width: 800px;
  }
  .userCenterImgOut {
    .upload-tip {
      display: block;
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>
<style>
.userCenterImgOut img {
  width: 160px;
  height: 160px;
  border-radius: 100px;
}
</style>
